module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"reset":"初期化","confirm":"完了"}}')
  delete Component.options._Ctor
}
